import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from "vue";
import { useDrawerTriggerStore } from "./drawer-trigger/index";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DrawerTrigger',
    setup(__props) {
        const isShown = ref(false);
        const drawerTriggerStore = useDrawerTriggerStore();
        const drawerClosed = () => {
            isShown.value = false;
            drawerTriggerStore.toggleWorkflow(isShown.value);
        };
        const openDrawer = () => {
            isShown.value = true;
            drawerTriggerStore.toggleWorkflow(isShown.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "trigger", { openDrawer: openDrawer }),
                (isShown.value)
                    ? _renderSlot(_ctx.$slots, "drawer", {
                        key: 0,
                        drawerClosed: drawerClosed
                    })
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
